<script lang="ts">
  // test
  import Data from "../Data.svelte";
</script>

<h3 class="modal_heading">
  <i class="fas fa-exclamation-circle" />
  NFT Staking Rewards Bug
</h3>

<Data label="What is affected">
  <small class="modal_p white_text">
    Accrued rewards may disappear for users who haven't claimed from this pool in within 40-60 days.
  </small>
</Data>

<Data label="Reclaiming lost rewards">
  <small class="modal_p white_text">
    We won't be reimbursing for missing DOE reward. Keep your NFTs staked at your own risk. The NFT staking support has been discontinued and DOE team is no longer responsible for the lost rewards due to the NFT staking bug.
  </small>
</Data>

<Data label="Status">
  <small class="modal_p white_text">
    Unpatched: The bug in the NFT staking contract is unpatched. Claim
    frequently, and stake additional NFTs at your own risk.
  </small>
</Data>

<small class="modal_p white_text">For further questions feel free to reach out on Twitter:
  <a href="https://twitter.com/DrPawwws"> @DrPawwws </a>
</small>

<style>
  h3 {
    margin-top: 0px;
  }

  pre {
    background-color: var(--button-color);
    color: var(--button-text-color);
    padding: 10px;
    border-radius: var(--border-radius);
    word-wrap: break-word;
    white-space: pre-wrap;
  }

  i {
    font-size: 0.9rem;
    opacity: 0.5;
  }
</style>
